import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setDesignProductTypeIdReducer = (state: DesignState, action: PayloadAction<number | undefined>) => {
  state.productTypeId = action.payload;
};

export default setDesignProductTypeIdReducer;
